export const picklistProductDefaultValues = { quantity: 1 };
